import { useSelector } from 'react-redux';

const useIsLearningSuperUser = () => {
  const user = useSelector((state) => state.authSlice?.userData);
  return user?.learningRoles?.includes('TRAINER_SUPER_ADMIN') || false;
};

export default useIsLearningSuperUser;
// example usage
